<template>
  <!-- <a class="logo" href="javascript:" title="GoFoodie 美食快一點! 辦公室美食外送"></a> -->
  <div>
    <div class="top_bar flex_center">
      <div class="shop_name">
        <a :href="menuUrl">{{ shopName }}</a>
      </div>

      <!-- 未登入狀態顯示 -->
      <!-- <div class="open_menu" style="display: none;"><a href="login"><i class="icon-user"></i></a></div> -->

      <!-- 已登入狀態顯示 -->
      <div class="open_menu" onclick="$('.menu_user').fadeIn(300);">
        <i class="icon-user-check"></i>
      </div>
    </div>

    <div class="menu_user">
      <div
        class="overlay_bg"
        onclick="$(this).closest('.menu_user').fadeOut(100);"
      ></div>
      <div class="menu_title">
        <div class="user_name">
          <i class="icon-user-check"></i> Hi, {{ userProfile.name }}
        </div>
        <button
          class="close"
          ref="categoryList"
          onclick="$(this).closest('.menu_user').fadeOut(100);"
        >
          <i class="icon-close"></i>
        </button>
      </div>
      <div class="menu_list" >
        <!-- <router-link :to="s.url" v-if="s.type === 'router-link'">
          <a href="javascript:"><i :class='[s.icon]'></i> {{s.label}}</a>
        </router-link> -->
        <a href="javascript:" v-for="(s, index) in sidebars" v-on:click="gotoSidebar(s)"><i :class='[s.icon]'></i> {{s.label}}</a>
      </div>
    </div>
    <div v-if="$router.currentRoute.meta.auth">
      <Auth />
    </div>
  </div>
</template>

<script>
import Auth from "@/components/Auth.vue";
import apis from "@/services/apis";

export default {
  name: "Header",
  components: {
    Auth,
  },
  data() {
    return {
      shopName: "",
      sidebars: [],
    };
  },
  computed: {
    logo() {
      return GLOBAL_ENV_LOGO;
    },
    userProfile() {
      try {
        let obj = JSON.parse(
          Base64.decode(localStorage.getItem("lineUserProfile"))
        );
        return obj;
      } catch (e) {
        return {};
      }
    },
  },
  methods: {
    changeLanguage(lang) {
      this.language = lang;
      // lang: this.$store.state.lang, // get lang 預設值 `en`
      this.$i18n.locale = lang;
    },
    signout() {
      console.log('check liff ' + typeof liff);
      if (liff) {
        console.log('logout');
        if (GLOBAL_ENV_SDKTYPE === "sso") {
          liff.logout();
          // 清空portal暫存的資料
          localStorage.removeItem('qcsso:uuid');
          localStorage.removeItem('lineUserProfile');
          localStorage.removeItem('lineUserId');
          this.$router.go(this.$router.currentRoute)
        }
      }
    },
    gotoSidebar(s) {
      if (s.type === 'function') {
        this[s.function]();

      } else if (s.type === 'router-link') {
        s.query.p = this.$router.currentRoute.query.p;
        s.query.a = this.$router.currentRoute.query.a;
        this.$router.push({
          path: s.path,
          query: s.query
        })
      } else if (s.type === 'href') {
        window.location.href = s.url
      }
    }
  },
  created() {
    let self = this;
    // taiwan default
    this.changeLanguage("tw"); // 這個動作坐在這邊，沒用到header的頁面就要記得切
    // this.changeCurrency("NTD");
    // console.log('hello router query ' + JSON.stringify(this.$router.currentRoute.query));
    if (this.$router.currentRoute.query.s) {
      // 不用判斷 GLOBAL_ENV_SDKTYPE 因為這個頁面只有web版才會用到
      apis
        .getShopInfo(this.$router.currentRoute.query.s)
        .then(function(shopData) {
          if (shopData && shopData.menuUrl) {
            self.menuUrl = shopData.webLink;
            self.shopName = shopData.name;
            self.sidebars = [];
            if (shopData.sidebars) {
              for (let i = 0; i < shopData.sidebars.length; ++i) {
                self.sidebars.push(shopData.sidebars[i]);
              }
            }
          }

          console.log("get shop done" + JSON.stringify(self.sidebars));
        });
    }
  },
  props: {
    msg: String,
  },
};
</script>
